import { Box, Text } from "@chakra-ui/react"

export const SidebarItem = ({label, number, onClick, setChildTarget, isActive}: SidebarItemProps) => <Box as="li" onClick={onClick} px={3} cursor='pointer'>
    <Text fontWeight='bold' fontSize='sm' mb={6} color={isActive ? 'primary.500' : undefined}  _hover={{color: 'primary.500'}}>
     {number} {label}
    </Text>
    <Box as="ul" ref={setChildTarget} listStyleType='none' />
    </Box>

export interface SidebarItemProps {
    label: string;
    level: number;
    number?: string;
    isActive?: boolean;
    isLoading?: boolean;
    onClick?: (e: React.BaseSyntheticEvent) => void;
    setChildTarget?: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
}

export type SidebarItemRender = (props: SidebarItemProps) => React.ReactNode;